import './map.css';
import React, { useState } from 'react';

import { APIProvider } from '@vis.gl/react-google-maps';
import { SplitLayout } from '@googlemaps/extended-component-library/react';

import Sidebar from './Sidebar';
import CustomMap from './CustomMap';

const API_KEY = process.env.REACT_APP_MAP_INSIGHT_GCP_KEY;

const MapLayout = () => {
  const [place, setPlace] = useState(undefined);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  return (
    <div className="App">
      <APIProvider
        solutionChannel="GMP_visgl_rgmlibrary_v1_extendedcomponentlibraryexample"
        apiKey={API_KEY}
        version="beta"
      >
        <SplitLayout
          rowLayoutMinWidth={700}
          style={{
            '--gmpx-fixed-panel-width-row-layout': isSidebarOpen
              ? '340px'
              : '0px',
            '--gmpx-fixed-panel-height-column-layout': isSidebarOpen
              ? '420px'
              : '0px',
          }}
        >
          <Sidebar place={place} setPlace={setPlace} isOpen={isSidebarOpen} />
          <CustomMap
            place={place}
            isSidebarOpen={isSidebarOpen}
            onSidebarToggle={() => setIsSidebarOpen(open => !open)}
          />
        </SplitLayout>
      </APIProvider>
    </div>
  );
};

export default MapLayout;
